import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: () =>
      import ('../pages/index.vue'),
  }, {
    path: '/index',
    name: '',
    component: () =>
      import ('../pages/index.vue'),
  }, {
    path: '/upload',
    name: '',
    component: () =>
      import ('../pages/upload.vue'),
  }, {
    path: '/review',
    name: '',
    component: () =>
      import ('../pages/review.vue'),
  }, {
    path: '/form',
    name: '',
    component: () =>
      import ('../pages/form.vue'),
  }, {
    path: '/amza',
    name: '',
    component: () =>
      import ('../pages/amazon-a.vue'),
  }, {
    path: '/amzb',
    name: '',
    component: () =>
      import ('../pages/amazon-b.vue'),
  }, {
    path: '/amzc',
    name: '',
    component: () =>
      import ('../pages/amazon-c.vue'),
  }, {
    path: '/join',
    name: '',
    component: () =>
      import ('../pages/join.vue'),
  }, {
    path: '/survey-form',
    name: '',
    component: () =>
      import ('../pages/survey-form.vue'),
  }, {
    path: '/survey-result',
    name: '',
    component: () =>
      import ('../pages/survey-result.vue'),
  }, {
    path: '/thanks',
    name: '',
    component: () =>
      import ('../pages/thanks.vue'),
  },
    /* contact-us */
    {
      path: '/contact-us',
      name: '',
      component: () =>
        import ('../pages/contact-us/index.vue'),
    },
    {
      path: '/pre-sales-inquiry',
      name: '',
      component: () =>
        import ('../pages/contact-us/pre-sales-inquiry.vue'),
    },
    {
      path: '/after-sales-inquiry',
      name: '',
      component: () =>
        import ('../pages/contact-us/after-sales-inquiry.vue'),
    },
    {
      path: '/submitted',
      name: '',
      component: () =>
        import ('../pages/contact-us/submitted.vue'),
    },

    /* installation-tutorials */
    {
      path: '/installation-tutorials',
      name: 'ItProdCategory',
      component: () =>
        import ('../pages/installation-tutorials/prod-category.vue'),
    },
    {
      path: '/it-search-result',
      name: 'ItProdSearchResult',
      component: () =>
        import ('../pages/installation-tutorials/search-result.vue'),
    },
    {
      path: '/it-prod-video-list/:cid',
      name: 'ItProdVideoList',
      component: () =>
        import ('../pages/installation-tutorials/prod-video-list.vue'),
      props: true
    },
    {
      path: '/it-prod-video-play/:vid',
      name: 'ItProdVideoPlay',
      component: () =>
        import ('../pages/installation-tutorials/prod-video-play.vue'),
      props: true
    },

    /* warranty-policy */
    {
      path: '/warranty-policy',
      name: 'WarrantyPolicyIndex',
      component: () =>
        import ('../pages/warranty-policy/index.vue'),
    },
    {
      path: '/warranty-claim',
      name: 'WarrantyClaim',
      component: () =>
        import ('../pages/warranty-policy/warranty-claim.vue'),
    },

    /* return-refund-policy */
    {
      path: '/return-refund-policy',
      name: 'ReturnRefundPolicy',
      component: () =>
        import ('../pages/return-refund-policy/index.vue'),
    },
    {
      path: '/cancel-order',
      name: 'CancelOrder',
      component: () =>
        import ('../pages/return-refund-policy/cancel-order.vue'),
    },
    {
      path: '/start-a-return',
      name: 'StartAReturn',
      component: () =>
        import ('../pages/return-refund-policy/start-a-return.vue'),
    },
    // {
    //   path: '/price-protection',
    //   name: 'PriceProtection',
    //   component: () =>
    //     import ('../pages/return-refund-policy/price-protection.vue'),
    // },
    // FAQs
    {
      path: '/faqs',
      name: 'FAQs',
      component: () =>
        import ('../pages/faqs/index.vue'),
    },
    // track-my-order
    {
      path: '/track-my-order',
      name: 'TrackMyOrder',
      component: () =>
        import ('../pages/track-my-order/index.vue'),
    },
    // shipping-policy
    {
      path: '/shipping-policy',
      name: 'ShippingPolicy',
      component: () =>
        import ('../pages/shipping-policy/index.vue'),
    },
    // package-protection
    {
      path: '/package-protection-claim',
      name: 'PackageProtectionClaim',
      component: () =>
        import ('../pages/package-protection/package-protection-claim.vue'),
    },

// b2b-contact-form
    {
      path: '/b2b-contact-form',
      name: 'B2bContactForm',
      component: () =>
        import ('../pages/b2b/contact-form.vue'),
    }


  ]
})


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js